import React from "react";
import { useLocation, Link } from "react-router-dom";
import { ROUTES } from "../Routes/routes";
import { firebaseServices } from "../services/firebase";
import { storageServices } from "../services/storage";
import { Trans } from "react-i18next";

var biz = storageServices.getCurrentUser();  

export function SideBar(props) {
  const sideBarRoutes = ROUTES.filter((v) => v.isSideBarItem);
  let location = useLocation();

  const currentRouteItem = ROUTES.find((v) => v.link === location.pathname);

  // function isPathActive(path) {
  //   return this.props.location.pathname.startsWith(path);
  // }

  // function onRouteChanged() {
  //   document.querySelector("#sidebar").classList.remove("active");
  //   Object.keys(this.state).forEach((i) => {
  //     this.setState({ [i]: false });
  //   });
  // }

  async function logOut() {
    await firebaseServices.signOut();
  }

  let biz_data = <></>;

  if (biz?.biz_title) {
    biz_data = (
      <li className="nav-item nav-profile">
        <a
          href="!#"
          className="nav-link"
          onClick={(evt) => evt.preventDefault()}
        >
          <div className="nav-profile-image">

            <img src={biz.biz_logo} alt="" onError={(e)=>{e.target.onerror = null; e.target.src="https://img.icons8.com/officel/80/000000/no-image.png"}}/>
            <span className="login-status online"></span>{" "}

          </div>
          <div className="nav-profile-text">
            <span className="font-weight-bold mb-2">{biz.biz_title}</span>
            <span className="text-secondary text-small">{biz.biz_type}</span>
          </div>
          <i className="mdi mdi-bookmark-check text-success nav-profile-badge"></i>
        </a>
      </li>
    );
  }
  return (
    <>
      <nav className="sidebar sidebar-offcanvas" id="sidebar">
        <ul className="nav">
          {biz_data}
          {sideBarRoutes.map((item, index) => (
            <li
              key={index}
              className={
                currentRouteItem.link === item.link
                  ? "nav-item active"
                  : "nav-item"
              }
            >
              <Link className="nav-link" to={item.link}>
                <span className="menu-title">
                  <Trans> {item.title}</Trans>
                </span>
                <i className={item.icon}></i>
              </Link>
            </li>
          ))}

          <li className="nav-item">
            <a className="nav-link" onClick={() => logOut()}>
              <span className="menu-title">
                <Trans>Sign out</Trans>
              </span>
              <i className="mdi mdi-logout menu-icon"></i>
            </a>
          </li>
        </ul>
      </nav>
      {/* <aside className="col-12 col-md-2 p-0 flex-shrink-1 customSidebar">
        <nav className="navbar navbar-expand flex-md-column flex-row align-items-end py-2">
          <div className="collapse navbar-collapse w-100">
            <ul className="flex-md-column flex-row navbar-nav w-100 justify-content-center">
              {sideBarRoutes.map((item, index) => (
                <li key={index} className="nav-item">
                  <Link to={item.link}>
                    <Button
                      id={
                        currentRouteItem.link === item.link
                          ? "navbar-button-active"
                          : "navbar-button-inactive"
                      }
                      className={"navbar-button"}
                      size="sm"
                      variant="outline-primary"
                      block
                    >
                      {item.title}
                    </Button>
                  </Link>
                </li>
              ))}
              <br />
              <li className="nav-item">
                <Button
                  onClick={() => firebaseServices.signOut()}
                  className="navbar-button"
                  size="sm"
                  variant="outline-primary"
                  block
                >
                  Sign out
                </Button>
              </li>
            </ul>
          </div>
        </nav>
      </aside> */}
    </>
  );
}
export default SideBar;
